import React, { Component } from 'react'
import MaterialIcon, { colorPalette } from 'material-icons-react';
import Loader from "../../components/elements/loader/Loader";
import Auth from "auth/Auth"
import HttpClient from "../../utils/HttpClient/HttpClient";
import history from 'routes/History/history';
import * as qs from "qs";
import { Link } from 'react-router-dom';

import CustomSnackbar from "components/CustomSnackbar/CustomSnackbar";

export default class LoginPage extends Component {


    email;
    password;
    httpClient;
    auth;
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.state = {
            requestLogin: false
        }

        this.httpClient = new HttpClient();
        this.auth = new Auth();
    }

    onPasswordChange = (val) => {
        this.password = val;
        // console.log(`onPasswordChange: ${val}`);
    }

    onEmailChange = (val) => {
        this.email = val;
        // console.log(`onEmailChange: ${val}`);
    }

    onLoginClick = () => {
        this.setState({ requestLogin: true });
        const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
        let credentials = { username: this.email, password: this.password };
        this.httpClient.post("oga/login", qs.stringify(credentials), config)
            .then((response) => {
                console.log("Login Successful");
                this.setState({ requestLogin: false });
                let payload = { user: response.data, token: response.headers.authorization };
                this.auth.setUser(payload.user);
                this.auth.setJWT(payload.token);
                history.push('/');
                console.dir(payload);
            })
            .catch((error) => {
                console.log("enter here error login request");
                this.setState({ requestLogin: false });
            })
    }

    render() {
        let requestLogin = this.state.requestLogin;
        return (
            <div className="login">
                <div className="login-max-width margin-auto">
                    <div className="login-icon w-100 centered">
                        <svg viewBox="0 0 357 357" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M356.533 178.267C356.533 276.721 276.72 356.533 178.267 356.533C79.812 356.533 0 276.721 0 178.267C0 79.812 79.812 -9.26654e-06 178.267 -9.26654e-06C276.72 -9.26654e-06 356.533 79.812 356.533 178.267Z"
                                fill="none" />
                            {/*#4a148c*/}
                            <path
                                d="M224.609 188.013C212.421 188.013 202.541 178.133 202.541 165.945C202.541 153.757 212.421 143.877 224.609 143.877C236.797 143.877 246.677 153.757 246.677 165.945C246.677 178.133 236.797 188.013 224.609 188.013ZM167.232 188.013C155.044 188.013 145.164 178.133 145.164 165.945C145.164 153.757 155.044 143.877 167.232 143.877C179.42 143.877 189.3 153.757 189.3 165.945C189.3 178.133 179.42 188.013 167.232 188.013ZM109.855 188.013C97.6668 188.013 87.7868 178.133 87.7868 165.945C87.7868 153.757 97.6668 143.877 109.855 143.877C122.043 143.877 131.923 153.757 131.923 165.945C131.923 178.133 122.043 188.013 109.855 188.013ZM259.919 165.945C259.919 146.444 244.109 130.636 224.609 130.636C212.787 130.636 202.329 136.453 195.921 145.373C189.512 136.453 179.055 130.636 167.232 130.636C155.409 130.636 144.952 136.453 138.544 145.373C136.297 142.247 133.555 139.504 130.427 137.257C139.348 130.848 145.164 120.391 145.164 108.568H131.924C131.924 120.756 122.043 130.636 109.855 130.636C90.3548 130.636 74.5468 146.445 74.5468 165.945C74.5468 185.445 90.3548 201.255 109.855 201.255C121.677 201.255 132.135 195.437 138.544 186.517C144.952 195.437 155.409 201.255 167.232 201.255C167.303 201.255 167.372 201.249 167.443 201.249V201.255C179.631 201.255 189.511 211.135 189.511 223.323C189.511 235.511 179.631 245.391 167.443 245.391C155.255 245.391 145.373 235.511 145.373 223.323C145.373 223.311 145.375 223.299 145.375 223.285H132.135C132.135 223.299 132.133 223.311 132.133 223.323C132.133 242.823 147.941 258.632 167.443 258.632C186.943 258.632 202.751 242.823 202.751 223.323C202.751 211.453 196.889 200.961 187.909 194.559C190.993 192.327 193.699 189.609 195.921 186.517C202.329 195.437 212.787 201.255 224.609 201.255C236.432 201.255 246.889 195.437 253.297 186.517C259.707 195.437 270.164 201.255 281.987 201.255V188.013C269.799 188.013 259.919 178.133 259.919 165.945Z"
                                fill="white" />
                        </svg>
                    </div>
                    <div className=" w-100">
                        <form className="form">
                            <div className="form-group">
                                <div className="input-group mb-3 username">
                                    <div className="input-group-prepend " >
                                        <span className="input-group-text border-dark bg-secondary">
                                            <MaterialIcon icon="email" size="18px" color="white" />
                                        </span>
                                    </div>
                                    <input type="email" className="form-control border-dark"
                                        onChange={(e) => this.onEmailChange(e.target.value)}
                                        aria-describedby="emailHelp" placeholder="Usuario" />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group mb-3 password">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text border-dark bg-secondary">
                                            <MaterialIcon icon="https" size="18px" color="white" />
                                        </span>
                                    </div>
                                    <input type="password" className="form-control border-dark so-shadow"
                                        onChange={(e) => this.onPasswordChange(e.target.value)}
                                        placeholder="Contraseña" />
                                </div>
                            </div>
                            <div className="w-100">
                                {
                                    requestLogin ? <Loader show={true} /> :
                                        <button type="submit"
                                            className="btn bg-secondary w-100 login-btn"
                                            onClick={() => this.onLoginClick()}>Ingresar</button>
                                }
                            </div>

                            <div className="w-100">
                                {!requestLogin ? <Link className="forgot-password" to="/pages/forgot-password">¿Has olvidado tu contraseña?</Link> : ""}
                            </div>

                        </form>
                    </div>
                </div>

                <CustomSnackbar />

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/layouts/Pages/LoginPage.jsx